<script>
import { connect } from 'vuex-connect';
import SettingsBox from '../scenes/SettingsBox.vue';

export default connect({
  gettersToProps: {
    hasCalledHelp: 'hasCalledHelp',
    station: 'currentStation',
    timerStatus: 'timerStatus',
  },
  stateToProps: {
    shouldShowLanguageBtn: state => !state.launcher.appState.overlay,
  },
  // stateToProps: {
  //   loading: state => state.launcher.loadings.getStation,
  // },
  actionsToEvents: {
    'launch-tutorial': 'startTutorial',
  },
})('SettingsBox', SettingsBox);
</script>
